import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-sub-item',
  templateUrl: './icon-sub-item.component.html',
  styleUrls: ['./icon-sub-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconSubItemComponent {}
